exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.option__description[data-v-ade736cc] {\n    white-space: normal !important;\n    line-height: 1.5rem;\n}\n.min-height[data-v-ade736cc] {\n    min-height: 44px;\n}\n", ""]);

// exports
